import classNames from 'classnames';
import React from 'react';
import { FunctionComponent } from 'react';
import styles from './AverageDonationBanner.scss';
import { useAverageDonation } from '../../hooks/useAverageDonation';
import { useOptimizely, usePageMeta } from '../../hooks';
import { buildQueryString } from '../../utils/buildQueryString';
import { useTranslation } from 'react-i18next';
import { PageStatus } from '../../../types/__generated__';

type AverageDonationProps = {
  experiments?: string[];
  successType?: string;
};

const AverageDonationBanner: FunctionComponent<AverageDonationProps> = ({
  experiments,
  successType,
}) => {
  const averageDonation = useAverageDonation();
  const { t } = useTranslation('common', { useSuspense: false });
  const { currentUrl, basePageData } = usePageMeta();
  const optimizely = useOptimizely();

  const urlParams = new URLSearchParams(window.location.search);
  const queryString = buildQueryString(
    experiments,
    successType,
    false,
    urlParams,
  );
  const donateUrl = `${currentUrl}/donate${queryString}`;
  const optimizelyShowAvrageDonationBanner = optimizely?.decide(
    'consumerdarkslide_2646480_top_donations',
  );

  const showBanner =
    averageDonation > 0 && optimizelyShowAvrageDonationBanner?.enabled;

  const pageIsActive = basePageData?.status === PageStatus.Active;

  return showBanner ? (
    <div
      className={classNames(
        `${styles.averageDonationBanner} jg-display-flex jg-flex-aic jg-space-psm jg-background--white`,
      )}
    >
      <span className={`${styles.donateIcon} jg-space-mrsm`} />
      <div>
        {t('supporters.averageDonation')}
        <strong className={styles.averageDonationAmount}>
          £{averageDonation}
          {'. '}
        </strong>
        {pageIsActive ? <a href={donateUrl}> Give Now</a> : null}
      </div>
    </div>
  ) : null;
};

export default AverageDonationBanner;
